import axios from 'src/request';

// eslint-disable-next-line import/prefer-default-export
export function getOrderResult(outTradeNo: string) {
  return axios({
    method: 'get',
    url: `/oa-real-estate/api/v1/pay/order/detail/${outTradeNo}`,
  });
}
